var map = {
	"./en": 5218,
	"./en/": 5218,
	"./en/index": 5218,
	"./en/index.js": 5218,
	"./en/translation": 8633,
	"./en/translation.js": 8633,
	"./fr": 2386,
	"./fr/": 2386,
	"./fr/index": 2386,
	"./fr/index.js": 2386,
	"./fr/translation": 8566,
	"./fr/translation.js": 8566
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2595;
module.exports = webpackAsyncContext;